import {
  PRICE_PLAN_GROUP_REQUEST,
  PRICE_PLAN_GROUP_SUCCESS,
  PRICE_PLAN_GROUP_ERROR,
  PRICE_PLAN_ASSOCIATION_REQUEST,
  PRICE_PLAN_ASSOCIATION_SUCCESS,
  PRICE_PLAN_ASSOCIATION_ERROR,
  ADDON_GROUP_REQUEST,
  ADDON_GROUP_SUCCESS,
  ADDON_GROUP_ERROR,
  EQUIPMENT_DETAILS_REQUEST,
  EQUIPMENT_DETAILS_SUCCESS,
  EQUIPMENT_DETAILS_FAILURE,
  SERVICE_NUMBER_REQUEST,
  SERVICE_NUMBER_SUCCESS,
  SERVICE_NUMBER_FAILURE,
  DEVICE_BRANDS_ERROR,
  DEVICE_BRANDS_REQUEST,
  DEVICE_BRANDS_SUCCESS,
  GET_MOBILE_SHARE_REQUEST,
  GET_MOBILE_SHARE_SUCCESS,
  GET_MOBILE_SHARE_ERROR,
  GET_MOBILE_SHARE_ELIGIBILITY_REQUEST,
  GET_MOBILE_SHARE_ELIGIBILITY_SUCCESS,
  GET_MOBILE_SHARE_ELIGIBILITY_ERROR,
  GET_DEVICES_BY_PLAN_GROUP_REQUEST,
  GET_DEVICES_BY_PLAN_GROUP_SUCCESS,
  GET_DEVICES_BY_PLAN_GROUP_ERROR,
  GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST,
  GET_SMART_TEMPLATE_LIST_DETAILS_SUCCESS,
  GET_SMART_TEMPLATE_LIST_DETAILS_FAILURE,
  GET_SMART_TEMPLATE_MENU_REQUEST,
  GET_SMART_TEMPLATE_MENU_SUCCESS,
  GET_SMART_TEMPLATE_MENU_FAILURE,
  UPDATE_SMART_TEMPLATE_NAME_REQUEST,
  UPDATE_SMART_TEMPLATE_NAME_SUCCESS,
  UPDATE_SMART_TEMPLATE_NAME_FAILURE,
  DELETE_SMART_TEMPLATE_REQUEST,
  DELETE_SMART_TEMPLATE_SUCCESS,
  DELETE_SMART_TEMPLATE_FAILURE,
  GET_CHECK_RESERVE_FAILURE,
  GET_CHECK_RESERVE_REQUEST,
  GET_CHECK_RESERVE_SUCCESS,
  GET_RESERVED_STOCKS_FAILURE,
  GET_RESERVED_STOCKS_REQUEST,
  GET_RESERVED_STOCKS_SUCCESS,
  GET_SMART_TEMPLATE_BY_ID_SUCCESS,
  GET_SMART_TEMPLATE_BY_ID_FAILURE,
  GET_SMART_TEMPLATE_BY_ID_REQUEST,
  GET_NUMBER_POOL_BILL_ACC_FAILURE,
  GET_NUMBER_POOL_BILL_ACC_REQUEST,
  GET_NUMBER_POOL_BILL_ACC_SUCCESS,
  GET_CHECKOUT_NUMBER_POOL_BILL_ACC_FAILURE,
  GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST,
  GET_CHECKOUT_NUMBER_POOL_BILL_ACC_SUCCESS,
  GET_NUMBER_POOL_EXISTING_BILL_ACCOUNT,
  GET_BUNDLEDADDONS_FOR_PRICEPLAN_ERROR,
  GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST,
  GET_BUNDLEDADDONS_FOR_PRICEPLAN_SUCCESS,
  SELECTED_PLAN,
  GET_DEP_RESELLER_ID_REQUEST,
  GET_DEP_RESELLER_ID_SUCCESS,
  GET_DEP_RESELLER_ID_ERROR
} from '@/actions/catalogue/actionTypes';

export const initialState = {
  pricePlanGroup: [],
  pricePlanGroupLoading: false,
  pricePlanGroupError: '',
  pricePlanAssociation: { bundledAddons: [], equipments: [], accessories: [] },
  pricePlanAssociationLoading: false,
  addonGroup: [],
  addonGroupLoading: false,
  equipmentVarients: {},
  equipmentDetailsLoading: false,
  svcNoData: {},
  serviceNumLoading: false,
  error: '',
  isLoading: false,
  deviceBrands: [],
  devicePlanAssociation: [],
  totalRecords: 0,
  mobileShareLines: [],
  mobileShareEligibilityLoading: false,
  mobileShareLinesLoading: false,
  mobileShareEligibilityError: '',
  mobileShareEligibility: false,
  mobileShareEligibilitySuccess: {},
  deviceStock: [],
  isStockLoading: false,
  stockError: '',
  smartTemplate: {
    smartTemplateMenus: [],
    smartTemplateMenusError: '',
    templateData: [],
    templateDataLoading: false,
    totalRecord: 0,
    templateDataError: '',
    isLoadingTemplateDetails: false,
    templateDetail: {}
  },
  numberPoolingBillingList: {},
  isNumberPoolingLoading: false,
  billingAddressListNumberPool: {},
  isBillingAddressDetailLoading: false,
  billAccount: '',
  dataLoading: false,
  bundledAddons: [],
  selectedPlan: {

  },
  depResellerIds: []
};

const getNumberPoolingDetails = (action, state) => {
  switch (action.type) {
    case GET_NUMBER_POOL_BILL_ACC_REQUEST:
      return {
        ...state,
        isNumberPoolingLoading: true
      };
    case GET_NUMBER_POOL_BILL_ACC_SUCCESS:
      return {
        ...state,
        numberPoolingBillingList: action.data,
        isNumberPoolingLoading: false
      };
    case GET_NUMBER_POOL_BILL_ACC_FAILURE:
      return {
        ...state,
        numberPoolingBillingList: {},
        isNumberPoolingLoading: false
      };

    case GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST:
      return {
        ...state,
        isBillingAddressDetailLoading: true
      };
    case GET_CHECKOUT_NUMBER_POOL_BILL_ACC_SUCCESS:
      return {
        ...state,
        isBillingAddressDetailLoading: false,
        billingAddressListNumberPool: action.data
      };
    case GET_CHECKOUT_NUMBER_POOL_BILL_ACC_FAILURE:
      return {
        ...state,
        isBillingAddressDetailLoading: false,
        billingAddressListNumberPool: {}
      };

    case GET_NUMBER_POOL_EXISTING_BILL_ACCOUNT:
      return {
        ...state,
        billAccount: action.billNo.billNo
      };
  }
}

const catalogueReducers = (state = initialState, action) => {
  const getSmartTemplate = (action, state) => {
    switch (action.type) {
      case GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST:
      case UPDATE_SMART_TEMPLATE_NAME_REQUEST:
      case DELETE_SMART_TEMPLATE_REQUEST:
        return {
          ...state,
          templateDataLoading: true
        }
      case GET_SMART_TEMPLATE_LIST_DETAILS_SUCCESS:
        return {
          ...state,
          templateData: action.data.smartTemplateConfigDtoList,
          totalRecord: action.data.totalRecords,
          templateDataLoading: false,
        }
      case GET_SMART_TEMPLATE_LIST_DETAILS_FAILURE:
        return {
          ...state,
          templateData: [],
          totalRecord: 0,
          templateDataLoading: false,
          templateDataError: action.error.response?.data?.message
        }

      case GET_SMART_TEMPLATE_MENU_REQUEST:
        return {
          ...state
        }
      case GET_SMART_TEMPLATE_MENU_SUCCESS:
        return {
          ...state,
          smartTemplateMenus: action.data,
          smartTemplateMenusError: '',
        }
      case GET_SMART_TEMPLATE_MENU_FAILURE:
        return {
          ...state,
          smartTemplateMenus: [],
          smartTemplateMenusError: action.error.response?.data?.message,
        }

      case UPDATE_SMART_TEMPLATE_NAME_SUCCESS:
      case UPDATE_SMART_TEMPLATE_NAME_FAILURE:
      case DELETE_SMART_TEMPLATE_SUCCESS:
      case DELETE_SMART_TEMPLATE_FAILURE:
        return {
          ...state,
          templateDataLoading: false
        }

      case GET_SMART_TEMPLATE_BY_ID_REQUEST:
        return {
          ...state,
          isLoadingTemplateDetails: true,
          templateDetail: {}
        }
      case GET_SMART_TEMPLATE_BY_ID_SUCCESS:
        return {
          ...state,
          isLoadingTemplateDetails: false,
          templateDetail: action.data
        }
      case GET_SMART_TEMPLATE_BY_ID_FAILURE:
        return {
          ...state,
          isLoadingTemplateDetails: false
        }
    }
  }

  switch (action.type) {
    case PRICE_PLAN_GROUP_REQUEST:
      return {
        ...state,
        pricePlanGroupLoading: true,
        pricePlanGroupError: ''
      };

    case PRICE_PLAN_GROUP_SUCCESS:
      return {
        ...state,
        pricePlanGroup: action.data,
        pricePlanGroupLoading: false,
        pricePlanGroupError: ''
      };

    case PRICE_PLAN_GROUP_ERROR:
      return {
        ...state,
        pricePlanGroup: [],
        pricePlanGroupError: action?.error?.response?.data.message,
        pricePlanGroupLoading: false
      };

    case GET_MOBILE_SHARE_REQUEST:
      return {
        ...state,
        mobileShareLinesLoading: true
      };

    case GET_MOBILE_SHARE_SUCCESS:
      return {
        ...state,
        mobileShareLines: action.data,
        mobileShareLinesLoading: false
      };

    case GET_MOBILE_SHARE_ERROR:
      return {
        ...state,
        mobileShareLines: [],
        mobileShareLinesLoading: false
      };

    case GET_MOBILE_SHARE_ELIGIBILITY_REQUEST:
      return {
        ...state,
        mobileShareEligibilityLoading: true,
        mobileShareEligibilityError: ''
      };

    case GET_MOBILE_SHARE_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        mobileShareEligibilityLoading: false,
        mobileShareEligibilitySuccess: action.data?.success,
        mobileShareEligibilityError: ''
      };

    case GET_MOBILE_SHARE_ELIGIBILITY_ERROR:
      return {
        ...state,
        mobileShareEligibilityLoading: false,
        mobileShareEligibilityError: action.error.response?.data?.message || 'COMMON_SYSTEM_ERROR'
      };

    case PRICE_PLAN_ASSOCIATION_REQUEST:
      return {
        ...state,
        pricePlanAssociationLoading: true
      };

    case PRICE_PLAN_ASSOCIATION_SUCCESS:
      return {
        ...state,
        pricePlanAssociation: action.data,
        pricePlanAssociationLoading: false
      };

    case PRICE_PLAN_ASSOCIATION_ERROR:
      return {
        ...state,
        pricePlanAssociation: {
          bundledAddons: [],
          equipments: [],
          accessories: []
        },
        pricePlanAssociationLoading: false
      };

    case ADDON_GROUP_REQUEST:
      return {
        ...state,
        addonGroupLoading: true
      };

    case ADDON_GROUP_SUCCESS:
      return {
        ...state,
        addonGroup: action.data,
        addonGroupLoading: false
      };

    case ADDON_GROUP_ERROR:
      return {
        ...state,
        addonGroup: [],
        addonGroupLoading: false
      };

    case EQUIPMENT_DETAILS_REQUEST:
      return {
        ...state,
        equipmentDetailsLoading: true
      };

    case EQUIPMENT_DETAILS_SUCCESS:
      return {
        ...state,
        equipmentVarients: action.data,
        equipmentDetailsLoading: false
      };

    case EQUIPMENT_DETAILS_FAILURE:
      return {
        ...state,
        equipmentVarients: {},
        equipmentDetailsLoading: false
      };

    case SERVICE_NUMBER_REQUEST:
      return {
        ...state,
        serviceNumLoading: true
      };

    case SERVICE_NUMBER_SUCCESS:
      return {
        ...state,
        svcNoData: { data: action.data, pagination: action.pagination },
        serviceNumLoading: false
      };

    case SERVICE_NUMBER_FAILURE:
      return {
        ...state,
        svcNoData: {},
        error: action.error.response?.data?.code,
        serviceNumLoading: false
      };

    case DEVICE_BRANDS_REQUEST:
    case DEVICE_BRANDS_ERROR:
      return {
        ...state
      };

    case DEVICE_BRANDS_SUCCESS:
      return {
        ...state,
        deviceBrands: action.data.deviceBrands
      };

    case GET_DEVICES_BY_PLAN_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case GET_DEVICES_BY_PLAN_GROUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        devicePlanAssociation: action.data.devicePlanAssociationResponses,
        totalRecords: action.data.totalRecords
      };

    case GET_DEVICES_BY_PLAN_GROUP_ERROR:
      return {
        ...state,
        isLoading: false
      };

    case GET_CHECK_RESERVE_REQUEST:
    case GET_RESERVED_STOCKS_REQUEST:
      return {
        ...state,
        isStockLoading: true
      };
    case GET_CHECK_RESERVE_SUCCESS:
    case GET_RESERVED_STOCKS_SUCCESS:
      return {
        ...state,
        isStockLoading: false,
        deviceStock: action.data,
        stockError: ''
      };
    case GET_CHECK_RESERVE_FAILURE:
    case GET_RESERVED_STOCKS_FAILURE:
      return {
        ...state,
        isStockLoading: false,
        deviceStock: [],
        stockError: action.error.response?.data?.message
      };
    case GET_SMART_TEMPLATE_LIST_DETAILS_REQUEST:
    case GET_SMART_TEMPLATE_LIST_DETAILS_SUCCESS:
    case GET_SMART_TEMPLATE_LIST_DETAILS_FAILURE:
    case GET_SMART_TEMPLATE_MENU_REQUEST:
    case GET_SMART_TEMPLATE_MENU_SUCCESS:
    case GET_SMART_TEMPLATE_MENU_FAILURE:
    case UPDATE_SMART_TEMPLATE_NAME_REQUEST:
    case UPDATE_SMART_TEMPLATE_NAME_SUCCESS:
    case UPDATE_SMART_TEMPLATE_NAME_FAILURE:
    case DELETE_SMART_TEMPLATE_REQUEST:
    case DELETE_SMART_TEMPLATE_SUCCESS:
    case DELETE_SMART_TEMPLATE_FAILURE:
    case GET_SMART_TEMPLATE_BY_ID_REQUEST:
    case GET_SMART_TEMPLATE_BY_ID_SUCCESS:
    case GET_SMART_TEMPLATE_BY_ID_FAILURE:
      return {
        ...state,
        smartTemplate: getSmartTemplate(action, state.smartTemplate)
      }

    case GET_NUMBER_POOL_BILL_ACC_REQUEST:
    case GET_NUMBER_POOL_BILL_ACC_SUCCESS:
    case GET_NUMBER_POOL_BILL_ACC_FAILURE:
    case GET_CHECKOUT_NUMBER_POOL_BILL_ACC_REQUEST:
    case GET_CHECKOUT_NUMBER_POOL_BILL_ACC_SUCCESS:
    case GET_CHECKOUT_NUMBER_POOL_BILL_ACC_FAILURE:
    case GET_NUMBER_POOL_EXISTING_BILL_ACCOUNT:
      return getNumberPoolingDetails(action, state);

    case GET_BUNDLEDADDONS_FOR_PRICEPLAN_REQUEST:
      return {
        ...state,
        dataLoading: true
      };

    case GET_BUNDLEDADDONS_FOR_PRICEPLAN_SUCCESS:
      return {
        ...state,
        bundledAddons: action.data,
        dataLoading: false
      };

    case GET_BUNDLEDADDONS_FOR_PRICEPLAN_ERROR:
      return {
        ...state,
        bundledAddons: [],
        dataLoading: false
      };
    case SELECTED_PLAN:
      return {
        ...state,
        dataLoading: false,
        selectedPlan: action.plan
      };
    case GET_DEP_RESELLER_ID_REQUEST:
      return {
        ...state,
        depResellerIds: []
      }
    case GET_DEP_RESELLER_ID_SUCCESS:
      return {
        ...state,
        depResellerIds: action.data
      }
      case GET_DEP_RESELLER_ID_ERROR:
        return {
          ...state,
          depResellerIds: []
        }
    default:
      return state;
  }
};

export default catalogueReducers;
